<div class="form-group" [formGroup]="form">
  <input type="text" formControlName="{{filter.name}}" placeholder="{{filter.placeholder}}" class="form-control">
</div>